package co.maytes.standupbot.dashboard.features.logs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.features.integrations.LoadState
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.dashboard.stores.rememberApiClient
import co.maytes.standupbot.shared.dto.logs.LogEventDto
import co.maytes.standupbot.shared.dto.logs.LogResponseDto

class LogsStore(private val api: ApiClient) {
    var loadState: LoadState by mutableStateOf(LoadState.Idle)
        private set
    var events: List<LogEventDto> by mutableStateOf(emptyList())
        private set
    var hasMore: Boolean by mutableStateOf(false)
        private set

    suspend fun load(workspaceId: String, levels: Set<String>) {
        if (loadState !is LoadState.Ready) loadState = LoadState.Loading
        val query = buildQuery(levels = levels, before = null)
        when (val r = api.get<LogResponseDto>("/api/v1/workspaces/$workspaceId/logs$query")) {
            is Result.Ok -> {
                events = r.value.events
                hasMore = r.value.hasMore
                loadState = LoadState.Ready
            }
            is Result.Err -> loadState = LoadState.Error(r.error)
        }
    }

    suspend fun loadMore(workspaceId: String, levels: Set<String>): Result<Unit, ApiError> {
        val before = events.lastOrNull()?.createdAt?.toString() ?: return Result.Ok(Unit)
        val query = buildQuery(levels = levels, before = before)
        return when (val r = api.get<LogResponseDto>("/api/v1/workspaces/$workspaceId/logs$query")) {
            is Result.Ok -> {
                events = events + r.value.events
                hasMore = r.value.hasMore
                Result.Ok(Unit)
            }
            is Result.Err -> Result.Err(r.error)
        }
    }

    private fun buildQuery(levels: Set<String>, before: String?): String {
        val parts = mutableListOf<String>()
        if (levels.isNotEmpty()) parts += "level=" + levels.joinToString(",")
        if (before != null) parts += "before=$before"
        return if (parts.isEmpty()) "" else "?" + parts.joinToString("&")
    }
}

@Composable
fun rememberLogsStore(): LogsStore {
    val api = rememberApiClient()
    return remember(api) { LogsStore(api) }
}
